import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

import {
  parsedContentStyle,
  StyledBabyPoopContainer,
  StyledBabyPoopListItem,
} from '../components/index.styled'

export const StyledBabyPoopIntroduce = styled.div``

export const StyledBabyPoopIntroduceMainColumn = styled.div``
export const StyledBabyPoopIntroduceSubColumn = styled.div``

export const StyledBabyPoopList = styled.div`
  padding: 40px 0;
`

export const StyledBabyPoopListDescription = styled.div`
  border-radius: 4px;
  border: 1px solid ${theme.colors.neutral100};
  padding: 12px;

  ${parsedContentStyle}
`

export const StyledBabyPoopContentWarning = styled.div`
  background-color: ${theme.colors.yellow200};
  border-radius: ${theme.borderRadius};
  display: flex;
  align-items: center;
  padding: 8px 18px;
  gap: 12px;

  svg {
    flex-shrink: 0;
  }
`

export const StyledBabyPoopListButtons = styled.div`
  margin-top: 48px;
  padding: 16px 0;
  border-top: 1px solid ${theme.colors.neutral100};

  ${StyledBabyPoopContainer} {
    display: flex;
    justify-content: flex-end;
    gap: 32px;
  }
`

export const StyledBabyPoopListGrid = styled.div`
  display: grid;
  ${MediaQueries.mbUp} {
    grid-gap: 24px;
    grid-template-columns: 1fr 1fr;
  }

  ${MediaQueries.mbDown} {
    grid-gap: 8px;
    grid-template-columns: 1fr;
  }

  ${StyledBabyPoopListItem} {
    height: 100%;
  }
`
